import module from './module.js'
// Components
import './components/cargaMovimientosBancarios/component.js'
import './components/cargaMovimientosBancarios/historial/component.js'
import './components/cargaMovimientosBancarios/historial/lista/component.js'
import './components/cargaMovimientosBancarios/historial/lista/item/component.js'
import './components/cargaMovimientosBancarios/historial/detallado/component.js'
import './components/cargaMovimientosBancarios/historial/eliminar/component.js'
import './components/cargaMovimientosBancarios/historial/eliminar/confirmar/component.js'
import './components/posicionbancaria/component.js'
import './components/posicionbancaria/estatus/component.js'
import './components/posicionbancaria/estatus/grid/component.js'
import './components/posicionbancaria/launcher/component.js'
import './components/posicionbancaria/prestamo/component.js'
import './components/posicionbancaria/prestamo/documentos/component.js'
import './components/posicionbancaria/prestamo/documentos/agregar/component.js'
import './components/posicionbancaria/prestamo/documentos/documento/component.js'
import './components/posicionbancaria/prestamo/documentos/eliminar/component.js'
import './components/posicionbancaria/prestamo/financiamiento/component.js'
import './components/posicionbancaria/prestamo/financiamiento/generador/component.js'
import './components/posicionbancaria/prestamo/financiamiento/tabla/component.js'
import './components/posicionbancaria/prestamo/informacion/component.js'
import './components/posicionbancaria/prestamos/component.js'
import './components/posicionbancaria/prestamos/agregar/component.js'
import './components/posicionbancaria/prestamos/editar/component.js'
import './components/posicionbancaria/prestamos/lista/component.js'
import './components/posicionbancaria/saldos/component.js'
import './components/posicionbancaria/saldos/cheques/transito/component.js'
import './components/posicionbancaria/saldos/lista/component.js'
import './components/posicionbancaria/saldos/lista/item/component.js'
import './components/posicionbancaria/saldos/prestamos/component.js'
import './components/saldoempleados/component.js'
import './components/saldoempleados/exportar/component.js'
import './components/saldoempleados/exportar/confirmar/component.js'
import './components/serviciosagregados/component.js'
import './components/serviciosagregados/exportar/component.js'
import './components/serviciosagregados/lista/component.js'
import './components/serviciosagregados/lista/item/component.js'
// Routes
import './routes/finances.js'
import './routes/finances/cargaMovimientosBancarios.js'
import './routes/finances/cargaMovimientosBancarios/historial.js'
import './routes/finances/posicionbancaria.js'
import './routes/finances/posicionbancaria/estatus.js'
import './routes/finances/posicionbancaria/prestamos.js'
import './routes/finances/posicionbancaria/saldos.js'
import './routes/finances/saldoEmpleados.js'
import './routes/finances/serviciosAgregados.js'
// Services
import './services/CuentasBancarias.js'
import './services/CargarMovimientosBancariosService.js'
import './services/CargarMovimientosBancariosCsvService.js'
import './services/CargarMovimientosBncariosCsvSantander.js'
import './services/CargarMovimientosBancariosHistorial.js'
import './services/CargarMovimientosBancariosHistorialDetalle.js'
import './services/FinanzasDetallesFacturacion.js'
import './services/FinanzasDivisas.js'
import './services/FinanzasGastosVsBancos.js'
import './services/FinanzasReporteFacturas.js'
import './services/FinanzasReporteFacturasExportarXML.js'
import './services/FinanzasSaldoEmpleados.js'
import './services/FinanzasServiciosAgregados.js'
import './services/FinanzasTablaRelacional.js'
import './services/Finances/Posicionbancaria/Divisas.js'
import './services/Finances/Posicionbancaria/Empresas.js'
import './services/Finances/Posicionbancaria/Estatus.js'
import './services/Finances/Posicionbancaria/Movimientos.js'
import './services/Finances/Posicionbancaria/Prestamo.js'
import './services/Finances/Posicionbancaria/Prestamos.js'
import './services/Finances/Posicionbancaria/Prestamo/Documento.js'
import './services/Finances/Posicionbancaria/Prestamo/Documentos.js'
//
import './_/bancosCuentas/controller.js'
import './_/bancosCuentas/detalle/detalle.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/agregar.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/cuentas.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/documentos.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/informacion.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/prestamos.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos/buscar.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos/servicio.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/prestamos/editar.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/prestamos/lista.js'
import './_/bancosCuentas/routes/cuentasBancarias/detalle/editar/prestamos/nuevo.js'
import './_/bancosCuentas/routes/cuentasBancarias/lista/lista.js'
import './_/clasificarmovimientos/components/component.js'
import './_/clasificarmovimientos/components/individual/component.js'
import './_/clasificarmovimientos/components/individual/archivos/component.js'
import './_/clasificarmovimientos/components/individual/lista/component.js'
import './_/clasificarmovimientos/components/individual/lista/item/component.js'
import './_/clasificarmovimientos/components/launcher/component.js'
import './_/clasificarmovimientos/components/masivo/component.js'
import './_/clasificarmovimientos/components/masivo/archivos/component.js'
import './_/clasificarmovimientos/components/masivo/lista/component.js'
import './_/clasificarmovimientos/components/masivo/lista/encabezado/component.js'
import './_/clasificarmovimientos/components/masivo/lista/item/component.js'
import './_/clasificarmovimientos/components/masivo/lista/match/component.js'
import './_/clasificarmovimientos/routes/finanzas-clasificarmovimientos.js'
import './_/clasificarmovimientos/services/FinanzasClasificarMovimientos.js'
import './_/comisionistas/Comisionistas.js'
import './_/comisionistas/controller.js'
import './_/detallesFacturacion/finances-detallesFacturacion.js'
import './_/detallesFacturacion/detalle/controller.js'
import './_/detallesFacturacion/detalle/comisionistas/controller.js'
import './_/detallesFacturacion/detalle/comisionistas/comisionista/controller.js'
import './_/detallesFacturacion/detalle/facturas/controller.js'
import './_/detallesFacturacion/detalle/facturas/factura/controller.js'
import './_/detallesFacturacion/detalle/nominas/controller.js'
import './_/detallesFacturacion/detalle/nominas/nomina/controller.js'
import './_/detallesFacturacion/lista/finances-detallesFacturacion-list.js'
import './_/divisas/finances-divisas.js'
import './_/divisas/agregar/finances-divisas-agregar.js'
import './_/empleadoprestamos/components/component.js'
import './_/empleadoprestamos/components/cotizador/component.js'
import './_/empleadoprestamos/components/cotizador/detalle/component.js'
import './_/empleadoprestamos/components/launcher/component.js'
import './_/empleadoprestamos/components/lista/component.js'
import './_/empleadoprestamos/components/lista/item/component.js'
import './_/empleadoprestamos/routes/finanzas-empleadoprestamos.js'
import './_/empleadoprestamos/services/FinanzasEmpleadoprestamos.js'
import './_/empresasfacturado/components/component.js'
import './_/empresasfacturado/routes/finanzas-empresasfacturado.js'
import './_/empresasfacturado/services/FinanzasEmpresasfacturado.js'
import './_/gastosVsBancos/finances-gastosVsBancos.js'
import './_/gastosVsBancos/editar/finances-gastosVsBancos-editar.js'
import './_/reportecomisiones/components/component.js'
import './_/reportecomisiones/components/launcher/component.js'
import './_/reportecomisiones/components/lista/component.js'
import './_/reportecomisiones/components/lista/item/component.js'
import './_/reportecomisiones/routes/finanzas-reportecomisiones.js'
import './_/reportecomisiones/services/FinanzasReportecomisiones.js'
import './_/reportedesaldosfacturacion/components/component.js'
import './_/reportedesaldosfacturacion/components/launcher/component.js'
import './_/reportedesaldosfacturacion/components/lista/component.js'
import './_/reportedesaldosfacturacion/components/lista/item/component.js'
import './_/reportedesaldosfacturacion/routes/finanzas-reportedesaldosfacturacion.js'
import './_/reportedesaldosfacturacion/services/FinanzasReportedesaldosfacturacion.js'
import './_/reporteFacturas/controller.js'
import './_/tablaRelacional/finances-tablaRelacional.js'
import './_/tablaRelacional/set/finances-tablaRelacional-set.js'
import './_/transferenciaRecursos/finanzas-transferenciaRecursos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/finanzas/index.js